import { render, staticRenderFns } from "./predition.vue?vue&type=template&id=5fc68a8a&"
import script from "./predition.vue?vue&type=script&lang=js&"
export * from "./predition.vue?vue&type=script&lang=js&"
import style0 from "./predition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports